export default{
    blue:"#00509d",
    yellow:"#feeeb3",
    yellowlight:"#fdc500",
    yellowdark:"#fca300",
    background1:"#ffffffbf",
    background:"#fafafa",
    background2:"#f0f0f0",
    RGB:"#00509d1a",
    green:"#36ab00",
    greenchat:"#98FF98",
    greenalarm:"#00ff00",
    
   
    primary: "#991b1e",
   secondary: "#FFA000",
   success:"#00C853",
   primarydark:"#C41C00",
   secondText: "#C4C4C4",
   secondText2:"#ECECEC",
   secondText3:"#979494",
   secondText4:"#29444d",
   
   
   
   RGB2:"rgba(255, 255, 255, 0.2)",
   RGB1:"rgba(255, 255, 255, 0.6)",
   RGB3:"rgba(0, 0, 0, 0.35)",
   black:"#222222",
   
};

